import { ModulePermissions } from '@config/permissions';

import { ADMINISTRATOR_ROLE_TYPE } from '@types';

import { FieldId } from '@kit/moderation-toggle-group/types';

export type MemberRating = number;

export enum SEX {
  MALE = 1,
  FEMALE = 2,
}

export enum LEVEL {
  BASIC = 1,
  PREMIUM = 2,
}

export enum PROF_SPECIALITY {
  CONSULTANT = 1,
  SEXOLOGIST = 2,
  COACH = 3,
  CERTIFIED = 4,
}

export enum ONLINE_STATUS {
  OFFLINE = 1,
  ONLINE = 2,
}

export enum PROFILE_MODERATION_STATUS {
  NEW_ON_MODERATION = 1,
  REPEATED_ON_MODERATION = 2,
  BY_COMPLAINT = 3,
  ACCEPTED = 4,
}

export enum PROFILE_BLOCK_TYPE {
  NOT_BLOCKED = 1,
  BLOCKED_BY_ADMIN = 2,
  BLOCKED_BY_SYSTEM = 3,
}

export enum PROFILE_MEDIA_TYPE {
  PHOTO = 1,
  VIDEO = 2,
}

export type BirthDate = string;

export type MemberProfileMediaItemId = number;

export type MemberProfileMediaItem = {
  id: MemberProfileMediaItemId;
  url?: string;
  name?: string;
  width: number;
  height: number;
  status: MODERATION_FIELD_STATUS;
  originMediaId?: MemberProfileMediaItemId;
  type: PROFILE_MEDIA_TYPE;
};

export type MemberProfileMediaItems = MemberProfileMediaItem[];

export type MemberProfileStateDto = {
  infoFilled: boolean;
  hasPhotos: boolean;
  hasDefaultPhoto: boolean;
  onModeration: boolean;
};

export type MemberId = string;
export type MemberProfileId = string;
export type MemberProfileFileId = number;

export type MemberProfileFile = {
  id: MemberProfileFileId;
  url?: string;
  name?: string;
  status?: MODERATION_FIELD_STATUS;
};

export type MemberProfileFiles = MemberProfileFile[];

export type MemberProfile = {
  birthDate: BirthDate;
  email: string;
  id: MemberId;
  pId: string;
  isBlocked: boolean;
  onlineStatus: ONLINE_STATUS;
  photoCount: number;
  ipIsBlocked?: boolean;
  isDeleted?: boolean;
  defaultSubjectName?: string;
  name?: string;
  onlineStatusChangeTime?: string;
  photoUrl?: string;
  sex?: SEX;
  deleteDateTime?: string;
};

export type MemberProfiles = MemberProfile[];

export enum MODERATION_FIELD_STATUS {
  NEW = 0,
  ACCEPTED = 1,
  DECLINED = 2,
}

export type MemberProfileModerationField = {
  field: FieldId;
  status?: MODERATION_FIELD_STATUS;
  value?:
    | number
    | string
    | boolean
    | MemberProfileStateDto
    | MemberProfileFiles;
};

export type MemberProfileModerationFields = MemberProfileModerationField[];

export type MemberProfileModerationFieldsByField = Record<
  FieldId,
  MemberProfileModerationField
>;

export type MemberProfileModerationMediaItem = Omit<
  MemberProfileMediaItem,
  'url' | 'width' | 'height'
>;

export type MemberProfileModerationMediaItems =
  MemberProfileModerationMediaItem[];

export type MemberProfileModeration = {
  files?: MemberProfileFiles;
  photos: MemberProfileModerationMediaItems;
  media: MemberProfileModerationMediaItems;
  fields?: MemberProfileModerationFields;
  finalComment?: string;
};

export type MemberAccountInfo = {
  email: string;
};

export enum MEMBER_PROFILE_MODERATION_RESULT_STATE {
  PENDING = 'pending',
  ACCEPTED = 'accepted',
  DECLINED = 'declined',
}

export type MemberProfileModerationResult = {
  state: MEMBER_PROFILE_MODERATION_RESULT_STATE;
  rejectedFieldLabels?: string[];
};

/////TODO:
export type AffiliateProfile = MemberProfile & {
  isPaidSearchEnabled: boolean;
  isWithdrawBlocked?: boolean;
  isInWhitelist?: boolean;
};

export type AffiliateProfilesList = AffiliateProfile[];

export type AffiliateProfileCredentials = Pick<AffiliateProfile, 'email'> & {
  password: string;
};

export type AffiliateProfileCredentialsList = AffiliateProfileCredentials[];

export type AffiliateWithdrawalInfo = Pick<
  AffiliateProfile,
  'email' | 'isWithdrawBlocked' | 'isInWhitelist'
> & {
  profileIds: AffiliateProfile['pId'][];
};

/////TODO:
export type AdministratorProfile = MemberProfile & {
  roleType: ADMINISTRATOR_ROLE_TYPE;
  permissions: ModulePermissions;
};

export type AdministratorProfiles = AdministratorProfile[];
